export default __webpack_public_path__ + "static/media/GR6 4A-2B-2EC.843d3823.jpg";